import { render, staticRenderFns } from "./UploadOrderByArchiveTabs.vue?vue&type=template&id=098022d1&scoped=true&"
import script from "./UploadOrderByArchiveTabs.vue?vue&type=script&lang=js&"
export * from "./UploadOrderByArchiveTabs.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=098022d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098022d1",
  null
  
)

export default component.exports